import "./LoadingSpinner.css";

function LoadingSpinner({
  text = "Loading..."
}) {
  return (
    <div className="loading-spinner-container">

      <div className="spinner"></div>

      <p>{text}</p>

    </div>
  );
}

export default LoadingSpinner;